import { render } from "./ReviewDocuments.vue?vue&type=template&id=79973820&scoped=true"
import script from "./ReviewDocuments.vue?vue&type=script&lang=js"
export * from "./ReviewDocuments.vue?vue&type=script&lang=js"

import "./ReviewDocuments.vue?vue&type=style&index=0&id=79973820&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79973820"]])

export default __exports__